"use client";

import { useMetaPageView } from "@/hooks/use-page-view";

export function AnalyticsProvider() {
  useMetaPageView();
  return null;
}
